import * as React from 'react';

var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function SvgBurger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 290 290",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M247.709 190.313c0 8.344-6.761 15.104-15.105 15.104H57.396c-8.343 0-15.104-6.76-15.104-15.104 0-8.343 6.76-15.104 15.104-15.104h175.208c8.344 0 15.105 6.761 15.105 15.104zM232.604 108.751s-1.522-1.813-12.083-6.042c-15.104-6.042-141.979-6.042-151.041 0-6.308 4.205-12.084 6.042-12.084 6.042-8.343 0-15.104 6.76-15.104 15.104 0 8.343 6.76 15.104 15.104 15.104h175.208c8.344 0 15.105-6.761 15.105-15.104 0-8.344-6.761-15.104-15.105-15.104z",
    fill: "#68362B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.333 211.459v28.698c0 7.51 6.084 13.594 13.594 13.594h166.146c7.509 0 13.593-6.084 13.593-13.594v-28.698H48.333zM145 36.25c-53.385 0-96.667 27.055-96.667 60.417h193.333c0-33.362-43.276-60.417-96.666-60.417z",
    fill: "#FFC107"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M247.709 145H42.292v24.167h205.417V145z",
    fill: "#FF3D00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M96.667 84.583a6.042 6.042 0 100-12.083 6.042 6.042 0 000 12.083zM108.75 66.458a6.042 6.042 0 10-.001-12.083 6.042 6.042 0 00.001 12.083zM120.834 84.583a6.042 6.042 0 10-.001-12.083 6.042 6.042 0 00.001 12.083z",
    fill: "#CE8106"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M253.211 213.893c-1.722-5.166-5.776-9.117-10.905-12.102-2.628 2.236-5.987 3.625-9.703 3.625H57.395c-3.903 0-7.425-1.522-10.108-3.951-3.486 3.48-6.205 7.395-7.262 10.929-2.47 8.223-3.836 21.436 7.576 20.645 5.365-.375 10.416-2.393 14.657-5.474 6.61-4.797 9.353-6.169 14.295-.048 4.803 5.945 8.627 11.08 14.73 3.908 6.331-7.449 7.14-11.557 17.967-9.352 11.335 2.314 20.844 10.168 32.408 11.999 5.631.882 8.078.773 11.419-4.06 2.725-3.939 5.208-12.446 10.476-13.25 8.591-1.311 2.109 8.283 1.861 12.627-.641 10.996 11.437 1.601 14.657-2.156 2.012-2.351 4.984-7.208 8.646-6.278 3.987 1.027 1.945 3.142 2.815 6.423.81 3.057 3.54 8.289 7.232 8.24 4.525-.06 6.652-8.047 8.935-11.285 1.855-2.61 5.311-7.148 8.936-6.924 4.018.254 5.117 5.274 7.135 8.567 4.145 6.761 15.624 13.002 23.025 7.6 4.737-3.462 8.356-13.871 6.416-19.683zM242.3 95.064H48.75c-5.788 2.453-10.193 5.541-11.25 9.063-2.49 8.223-2.15 14.905 9.352 14.113 5.402-.374 10.489-2.392 14.766-5.473 6.664-4.798 9.425-6.169 14.41-.049 4.84 5.945 8.694 11.081 14.838 3.909 6.38-7.449 7.196-11.558 18.101-9.352 11.431 2.314 21.007 10.168 32.667 11.998 5.667.883 8.15.774 11.497-4.06 2.749-3.939 5.251-12.445 10.567-13.249 8.658-1.311 2.127 8.283 1.873 12.627-.64 10.996 11.522 1.601 14.766-2.157 2.03-2.35 5.027-7.207 8.712-6.277 4.018 1.027 1.964 3.142 2.84 6.422.815 3.057 3.57 8.289 7.286 8.241 4.567-.06 6.706-8.047 9.014-11.286 1.861-2.61 5.347-7.147 8.996-6.924 4.048.254 5.16 5.275 7.184 8.568 4.175 6.76 15.75 13.001 23.206 7.6 4.779-3.462 4.833-5.818 2.87-11.63-1.469-4.399-4.417-8.465-8.145-12.084z",
    fill: "#8BC34A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M235.625 175.21c-90.625 0-126.875 18.125-126.875 18.125S84.583 175.21 54.375 175.21v-6.042h181.25v6.042zM54.375 145.001c90.625 0 126.875 18.125 126.875 18.125s24.167-18.125 54.375-18.125v-6.042H54.375v6.042z",
    fill: "#FFEB3B"
  })));
}

export { SvgBurger as default };